export const AppConfig = {
  siteName: "Sistema Cancerígenos - CPA"
};

export const FormConfig = {
  DefaultRules: [
    { required: true, message: "Por favor ingrese un valor" }
  ],

  DefaultLayout: {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 }
  },

  // Filtro de búsqueda seguro para Select (Ant Design)
  DefaultSelectFilter: (input, option) => {
    const text =
      option?.label ??
      option?.children ??
      option?.value ??
      "";

    return text
      .toString()
      .toLowerCase()
      .includes(input.toLowerCase());
  }
};

export const MomentConfig = {
  tz: "America/Argentina/Buenos_Aires"
};

export const GLOBAL_FORM_ITEM_LAYOUT = {
  wrapperCol: {
    offset: 8,
    span: 16
  }
};
